// extracted by mini-css-extract-plugin
export default {"mainCon":"Overview_mainCon__CqjhJ","Box":"Overview_Box__pHaVF","ItemDiv":"Overview_ItemDiv__Beotg","Heading":"Overview_Heading__m6gQ3"};